// extracted by mini-css-extract-plugin
module.exports = {"input":"InteractiveCircle__input--mtb22RAFsI","input-menu":"InteractiveCircle__input-menu--70nK4k8BWX"};